import { EVENT_COLOR_CLICKED } from './constants.mjs'
import createProps from '@kissui/helpers/src/props.helpers'

import { dispatchEvent } from '@kissui/helpers/src/assets/js/eventDispatch'

class color extends HTMLElement {
    connectedCallback() {
        this.props = createProps(this.attributes)
        this.render()
        this.createEventListeners()
    }

    createEventListeners() {
        this.addEventListener('click', this.handleClick)
    }

    render() {
        const { link, label, code, a11y_label = 'color', selected, size = 'large' } = this.props

        const element = document.createElement(link ? 'a' : 'button')

        if (link) {
            element.setAttribute('href', link)
        }
        if (label) {
            element.setAttribute('title', label)
            element.setAttribute('aria-label', `${label} ${a11y_label}`)
        }
        if (selected === 'true') {
            element.setAttribute('class', 'selected')
        }

        this.classList.add(size)

        element.innerHTML = `
            <div><span style="background-color: ${code}"></span></div>
        `
        this.innerHTML = element.outerHTML
    }

    handleClick() {
        const { sku } = this.props
        dispatchEvent({
            element: this,
            eventName: EVENT_COLOR_CLICKED,
            args: { sku }
        })
    }
}

customElements.get('nb-color') || customElements.define('nb-color', color)

export default color
